import { createSignal, onMount, onCleanup, type Component } from 'solid-js'
import { MS_PER_SECOND } from '../../../features/shared/time-units'
import { getOrCreateDeadline, formatTime } from '../countdown.utils'

interface Props { storageKey: string }

const CountdownTimer: Component<Props> = (props) => {
  const deadline = getOrCreateDeadline(props.storageKey)
  const [remaining, setRemaining] = createSignal(Math.max(0, deadline - Date.now()))
  let interval: ReturnType<typeof setInterval> | undefined

  onMount(() => {
    if (remaining() > 0) {
      interval = setInterval(() => {
        const r = Math.max(0, deadline - Date.now())
        setRemaining(r)
        if (r === 0) {
          clearInterval(interval)
        }
      }, MS_PER_SECOND)
    }
  })

  onCleanup(() => {
    if (interval !== undefined) clearInterval(interval)
  })

  return (
    <div class='flex items-center justify-between px-6 py-2 bg-amber-50 border-l-4 border-amber-400'>
      <span class='text-amber-800 font-semibold font-poppins text-sm'>⏰ Offer expires in</span>
      <span class='text-amber-700 font-bold text-lg tracking-wide'>{formatTime(remaining())}</span>
    </div>
  )
}

export default CountdownTimer
